/* ---------------------------------------------------------------------------------------------------------------------
   LENUMA RESERVIERUNGS-LEISTE
   ---------------------------------------------------------------------------------------------------------------------
   Zaehlt die eingestellte Dauer herunter. Der Startzeitpunkt liegt im
   sessionStorage, damit die Leiste beim Seitenwechsel weiterlaeuft statt neu
   zu beginnen - sonst waere der Wert bei jedem Klick wieder voll.

   Die Leiste haengt an einem Custom Element. Der Theme-Drawer wird bei jeder
   Warenkorb-Aenderung komplett neu gezeichnet; connectedCallback laeuft dann
   erneut und der Countdown greift ohne zusaetzliche Verdrahtung.
   --------------------------------------------------------------------------------------------------------------------- */

(function () {
  const KEY = 'lenuma-cart-timer-start';

  class LenumaCartTimer extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-lenuma-timer-value]');
      if (!this.output) return;

      this.duration = (parseInt(this.getAttribute('duration'), 10) || 5) * 60 * 1000;

      /* Zustaende zuruecksetzen, falls dieses Element schon einmal gelaufen
         ist. Der Drawer wird nicht in jedem Fall komplett neu gezeichnet. */
      this.classList.remove('is-urgent', 'is-expired');
      this.start();
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    get startedAt() {
      const stored = parseInt(window.sessionStorage.getItem(KEY), 10);

      if (!stored || Number.isNaN(stored) || Date.now() - stored > this.duration) {
        const now = Date.now();
        window.sessionStorage.setItem(KEY, String(now));
        return now;
      }

      return stored;
    }

    start() {
      const startedAt = this.startedAt;

      const tick = () => {
        const left = this.duration - (Date.now() - startedAt);
        const expired = left <= 0;
        const totalSeconds = expired ? 0 : Math.ceil(left / 1000);

        /* Beide Zustaende werden bei jedem Durchlauf neu gesetzt, nicht nur
           beim Wechsel. Ein einmal gesetztes is-expired blieb sonst haengen,
           wenn die Zeit spaeter wieder von vorn laeuft - dann stand die
           Ablaufmeldung neben dem laufenden Countdown. */
        this.classList.toggle('is-expired', expired);

        /* Letzte Minute: ab 00:59. Der Vergleich laeuft ueber die gerundeten
           Sekunden und nicht ueber die Millisekunden - sonst kaeme der Wechsel
           eine Sekunde zu frueh, weil oben aufgerundet wird. */
        this.classList.toggle('is-urgent', expired === false && totalSeconds < 60);

        if (expired) {
          window.clearInterval(this.interval);

          /* Ohne hinterlegten Ablauftext bleibt es beim alten Verhalten und
             die Leiste verschwindet. */
          this.hidden = !this.hasAttribute('has-expired-text');
          return;
        }

        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        this.output.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        this.hidden = false;
      };

      tick();
      window.clearInterval(this.interval);
      this.interval = window.setInterval(tick, 1000);
    }
  }

  if (!window.customElements.get('lenuma-cart-timer')) {
    window.customElements.define('lenuma-cart-timer', LenumaCartTimer);
  }

  document.addEventListener('cart:change', (event) => {
    const cart = event.detail && event.detail.cart;

    /* Leerer Warenkorb heisst: die naechste Reservierung faengt von vorn an. */
    if (cart && cart.item_count === 0) {
      window.sessionStorage.removeItem(KEY);
    }

    /* Neu auswerten, ohne den laufenden Countdown zurueckzusetzen: start()
       liest den gespeicherten Startzeitpunkt und beginnt nur dann von vorn,
       wenn dieser abgelaufen oder geloescht ist.

       Noetig, weil der Drawer nach einer Aenderung nicht zwingend komplett
       neu gezeichnet wird. Ohne das bliebe eine abgelaufene Leiste stehen,
       obwohl die Reservierung wieder laeuft. */
    document.querySelectorAll('lenuma-cart-timer').forEach((timer) => {
      if (typeof timer.start === 'function') {
        timer.classList.remove('is-urgent', 'is-expired');
        timer.start();
      }
    });
  });
})();
